export default "__VITE_ASSET__DVwaQEif__"